import {
  Button,
  ButtonGroup,
  Checkbox,
  Flex,
  Heading,
  SimpleGrid,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from '@chakra-ui/react'
import ModuleBrandInFilter from './components/ModuleBrandInFilter'
import { usePatchNotes } from '../../contexts/PatchNotes/Provider'
import CustomCalendar from './components/Calendar'

export default function FilterContainer() {
  const { categoriesFilters, setCategoriesFilters, modulesFilters, setModulesFilters } = usePatchNotes()

  const CategoryCard = ({ icon, label, value }: { icon: string; label: string; value: string }) => {
    return (
      <Flex border="1px" borderColor="borderColor" rounded="md" p={2} gap={1} bg="bgContent">
        <Checkbox
          autoFocus={false}
          defaultChecked={categoriesFilters[value]}
          onChange={(event) => setCategoriesFilters({ ...categoriesFilters, [value]: event.target.checked })}
        >
          <Flex>
            <Text fontSize="md" fontWeight="bold">
              {icon}
            </Text>
            <Text fontSize="md">{label}</Text>
          </Flex>
        </Checkbox>
      </Flex>
    )
  }

  const ModuleCard = ({ moduleName }: { moduleName: string }) => {
    return (
      <Flex border="1px" borderColor="borderColor" rounded="md" p={2} gap={1} bg="bgContent">
        <Checkbox
          autoFocus={false}
          defaultChecked={modulesFilters[moduleName]}
          onChange={(event) => setModulesFilters({ ...modulesFilters, [moduleName]: event.target.checked })}
        >
          <Flex>
            <ModuleBrandInFilter module={moduleName} />
          </Flex>
        </Checkbox>
      </Flex>
    )
  }

  return (
    <Flex
      w="full"
      flexDir="column"
      p={4}
      gap={2}
      borderLeft="1px solid"
      borderColor="borderColor"
      h="calc(100vh - 63px)"
      overflowY="scroll"
    >
      <Flex flexDir="column" gap={4}>
        <Heading size="sm" fontWeight="bold">
          Calendário
        </Heading>
        <CustomCalendar />
      </Flex>

      <Accordion allowToggle>
        <AccordionItem>
          <h2>
            <AccordionButton>
              <Box as="span" flex="1" textAlign="left">
                Filtros avançados
              </Box>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4}>
            <Flex flexDir="column" gap={4}>
              <Flex alignItems="center" justifyContent={'space-between'}>
                <Heading size="sm" fontWeight="bold">
                  Categorias
                </Heading>
                <Flex>
                  <ButtonGroup size="xs" isAttached variant="outline">
                    <Button
                      onClick={() =>
                        setCategoriesFilters({
                          ADJUSTMENTS: true,
                          ADVERTISEMENT: true,
                          FEATURE: true,
                          FIX: true,
                        })
                      }
                    >
                      Marcar todos
                    </Button>
                    <Button
                      onClick={() =>
                        setCategoriesFilters({
                          ADJUSTMENTS: false,
                          ADVERTISEMENT: false,
                          FEATURE: false,
                          FIX: false,
                        })
                      }
                    >
                      Desmarcar todos
                    </Button>
                  </ButtonGroup>
                </Flex>
              </Flex>

              <SimpleGrid columns={4} gap={4}>
                <CategoryCard icon="🛠️" label="Ajustes" value="ADJUSTMENTS" />
                <CategoryCard icon="📣" label="Anúncios" value="ADVERTISEMENT" />
                <CategoryCard icon="🚀" label="Recursos" value="FEATURE" />
                <CategoryCard icon="🐛" label="Correções" value="FIX" />
              </SimpleGrid>
            </Flex>

            <Flex flexDir="column" gap={4} mt={6}>
              <Flex alignItems="center" justifyContent={'space-between'}>
                <Heading size="sm" fontWeight="bold">
                  Módulos
                </Heading>
                <Flex>
                  <ButtonGroup size="xs" isAttached variant="outline">
                    <Button
                      onClick={() =>
                        setModulesFilters({
                          ACTIVITIES: true,
                          APP_CITIZEN: true,
                          ATTENDANCES: true,
                          CITIZEN_PORTAL: true,
                          CITIZEN_PROFILE: true,
                          INSTITUTIONAL_MANAGEMENT: true,
                          OBSERVATORY: true,
                          REGULATION: true,
                          SCHEDULES: true,
                          SERVICES_LETTER: true,
                          UNIFIED_LOGIN: true,
                          ADJUSTMENTS: true,
                          VULNERABILITY_ALERTS: true,
                        })
                      }
                    >
                      Marcar todos
                    </Button>
                    <Button
                      onClick={() =>
                        setModulesFilters({
                          ACTIVITIES: false,
                          APP_CITIZEN: false,
                          ATTENDANCES: false,
                          CITIZEN_PORTAL: false,
                          CITIZEN_PROFILE: false,
                          INSTITUTIONAL_MANAGEMENT: false,
                          OBSERVATORY: false,
                          REGULATION: false,
                          SCHEDULES: false,
                          SERVICES_LETTER: false,
                          UNIFIED_LOGIN: false,
                          ADJUSTMENTS: false,
                          VULNERABILITY_ALERTS: false,
                        })
                      }
                    >
                      Desmarcar todos
                    </Button>
                  </ButtonGroup>
                </Flex>
              </Flex>

              <SimpleGrid columns={3} gap={4}>
                {/* <ModuleCard moduleName="GENERAL" /> */}
                <ModuleCard moduleName="ACTIVITIES" />
                <ModuleCard moduleName="APP_CITIZEN" />
                <ModuleCard moduleName="ATTENDANCES" />
                <ModuleCard moduleName="CITIZEN_PORTAL" />
                <ModuleCard moduleName="CITIZEN_PROFILE" />
                {/* <ModuleCard moduleName="DATA_INTEGRATOR" /> */}
                {/* <ModuleCard moduleName="DIGITAL_ARCHIVE" /> */}
                {/* <ModuleCard moduleName="GEO" /> */}
                <ModuleCard moduleName="INSTITUTIONAL_MANAGEMENT" />
                {/* <ModuleCard moduleName="INVENTORY" /> */}
                {/* <ModuleCard moduleName="MESSENGER" /> */}
                <ModuleCard moduleName="OBSERVATORY" />
                {/* <ModuleCard moduleName="PROCESSES_AND_DOCUMENTS" /> */}
                <ModuleCard moduleName="REGULATION" />
                <ModuleCard moduleName="SCHEDULES" />
                <ModuleCard moduleName="SERVICES_LETTER" />
                <ModuleCard moduleName="UNIFIED_LOGIN" />
                <ModuleCard moduleName="VULNERABILITY_ALERTS" />
              </SimpleGrid>
            </Flex>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Flex>
  )
}
